const styles = theme => ({
    h3: {
        color: 'white',
        fontFamily: 'Montserrat',
        fontSize: '1rem',
        lineHeight: '24px',
        letterSpacing: '0.02em',
        fontWeight: '600',
        margin: 0,
        marginBottom: '20px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            fontSize: '18px',
            lineHeight: '27px'
        }
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '50px',
        maxWidth: '100%',
        height: '93px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            justifyContent: 'center'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 450)]: {
            transform: 'scale(0.9)',
            maxWidth: '100vw',
            width: '100vw',
            marginLeft: '-1rem',
            justifyContent: 'space-between'
        }
    }
})

export default styles